import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { olatheConfig } from "./data";

export default function OlathePage() {
  return <CityPageTemplate config={olatheConfig} />;
}